import styled from 'styled-components';

import { useTranslation } from 'next-i18next';
import Theme from '../../../styles/Theme';
import { DirectionProfiles } from '../../../models/MapBox';
import { meterToString } from '../../../utils/distance';
import { convertMinuteToString } from '../../../utils/time';
import { IconOnBikeSVG } from '../svg/IconOnBikeSVG';
import { IconOnFootSVG } from '../svg/IconOnFootSVG';
import { IconOnVehiculeSVG } from '../svg/IconOnVehiculeSVG';

interface Props {
	directionProfile: DirectionProfiles;
	minutes: number;
	meters: number;
}

const StyledDistance = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	gap: ${(props) => 4 / props.theme.fontSizeBase}rem;

	padding: ${(props) => 4 / props.theme.fontSizeBase}rem ${(props) => 12 / props.theme.fontSizeBase}rem ${(props) => 4 / props.theme.fontSizeBase}rem ${(props) => 8 / props.theme.fontSizeBase}rem;

	color: ${(props) => props.theme.black};
`;

const StyledTime = styled.span`
	font-family: 'Plus Jakarta Sans', sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: ${(props) => 12 / props.theme.fontSizeBase}rem;
	line-height: ${(props) => 16 / props.theme.fontSizeBase}rem;
`;

const StyledMeters = styled.span`
	font-family: 'Plus Jakarta Sans', sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: ${(props) => 10 / props.theme.fontSizeBase}rem;
	line-height: ${(props) => 14 / props.theme.fontSizeBase}rem;
	opacity: 0.4;
`;

export const DistanceIconValueMeter = ({ directionProfile, minutes, meters }: Props) => {
	const { t } = useTranslation(['common']);

	return (
		<StyledDistance>
			{ directionProfile === 'walking' && <IconOnFootSVG width={24} height={24} color={Theme.black}/> }
			{ directionProfile === 'cycling' && <IconOnBikeSVG width={24} height={24} color={Theme.black}/> }
			{ directionProfile === 'driving' && <IconOnVehiculeSVG width={24} height={24} color={Theme.black}/> }

			<StyledTime>{ convertMinuteToString(t, minutes, true) }</StyledTime>
			<StyledMeters>({ meterToString(t, meters) })</StyledMeters>
		</StyledDistance>
	);
};
